export default __webpack_public_path__ + "static/media/590.4bb4217c.png";